import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import { Document } from '../../../document-data/document.model';
import { Billing } from '../../../document-data/sub-models/billing.model';
import {
  CREDIT_MEMOS_MASTER_ROUTE,
  ESTIMATES_MASTER_ROUTE,
  INVOICES_MASTER_ROUTE,
  PURCHASE_ORDERS_MASTER_ROUTE,
} from '../../../main/main.data';
import { IRouter } from '../../../shared/interfaces/router.interface';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';

@Injectable()
export class RecentlyEditedListItemBuilder {
  constructor(
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildViewDocumentRoute(
    recentlyEditedDocument: Document,
    trackingScreenName: TrackingScreenNamesEnum
  ): IRouter {
    const documentId: string = recentlyEditedDocument.id;
    let route: string[];

    switch (recentlyEditedDocument.documentType) {
      case DocumentTypesEnum.invoice:
        route = [INVOICES_MASTER_ROUTE, documentId];
        break;
      case DocumentTypesEnum.estimate:
        route = [ESTIMATES_MASTER_ROUTE, documentId];
        break;
      case DocumentTypesEnum.purchase_order:
        route = [PURCHASE_ORDERS_MASTER_ROUTE, documentId];
        break;
      case DocumentTypesEnum.credit_memo:
        route = [CREDIT_MEMOS_MASTER_ROUTE, documentId];
        break;
      default:
        route = [];
        break;
    }

    return {
      route,
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        'recent_document',
        trackingScreenName
      ),
    };
  }

  buildMainTranslationParams(recentlyEditedDocument: Document): any {
    const billing: Billing = recentlyEditedDocument.billing;
    let clientReference: string;

    if (billing) {
      clientReference = billing.name ? billing.name : billing.email;
    }

    return {
      docNumber: recentlyEditedDocument.docNumber,
      clientReference:
        clientReference || this._translateService.instant('LABEL.NO_CLIENT'),
    };
  }
}
